export interface Config {
    isLocal: boolean;
    apiBaseUrl: string;
}

const localConfig: Config = {
    isLocal: true,
    apiBaseUrl: 'http://127.0.0.1:8000/',
}

const prodConfig: Config = {
    isLocal: false,
    apiBaseUrl: process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/` : 'https://api.sun-tap.com/',
}

let config: Config;

switch (process.env.REACT_APP_URLS) {
    case 'local':
        config = localConfig;
        break;
    case 'prod':
        config = prodConfig;
        break;
    default:
        config = localConfig;
}

// Ensure apiBaseUrl always ends with a trailing slash
if (config.apiBaseUrl && !config.apiBaseUrl.endsWith('/')) {
    config.apiBaseUrl = `${config.apiBaseUrl}/`;
}

const configToExport = {
    ...config,
}
export default configToExport;